export default __webpack_public_path__ + "static/media/ows.a69f5309.png";